<template>
	<div class="job-container">
		<div class="job-content">
			<!-- 简历信息--start -->
			<div class="information-main">
				<!-- 基本信息 -->
				<div class="resume-info">
					<div class="avatar-container">
						<img src="@/assets/index/index-zw2.png" alt="头像" class="avatar-img" />
					</div>
					<div class="basic-info">
						<div class="name-container">
							<h2 class="name">张某某</h2>
							<div class="tags">
								<span class="tag tag-status">离职随时到岗</span>
								<span class="tag">武汉·洪山区</span>
								<span class="tag">3-5年</span>
								<span class="tag">本科</span>
								<span class="tag">25岁</span>
							</div>
						</div>
						<div class="cert-info">
							<div class="cert-item">
								<span class="cert-label">求职意向：</span>
								<span class="cert-value">PMC注册安全工程师</span>
							</div>
							<div class="cert-item">
								<span class="cert-label">专业证书：</span>
								<span class="cert-value">建筑电工</span>
							</div>
							<div class="cert-item">
								<span class="cert-label">更新时间：</span>
								<span class="cert-value">2024-12-25</span>
							</div>
						</div>
					</div>
					<div class="salary-info">
						<div class="salary-label">期望薪资</div>
						<div class="salary">15k~20k/月</div>
					</div>
				</div>

				<!-- 简历投递板块--start -->
				<div class="delivery-container">
					<div class="tab-pane-container">
						<!-- tab头部区域--start -->
						<div class="tab-pane-header">
							<!-- tab选项 -->
							<div class="tab-pane-navs">
								<div
									v-for="(item, index) in recruitmentTabs"
									:key="index"
									:class="['tab-pane-item', { active: activeTab === index }]"
									@click="activeTab = index"
								>
									{{ item.name }}
									<!-- 数字标签 -->
									<span class="tab-pane-item-badge">20</span>
								</div>
							</div>
						</div>
						<!-- tab头部区域--end -->

						<!-- tab内容区域--start -->
						<div class="tab-pane-content">
							<!-- 已投递内容区域--start -->
							<div :class="['tab-pane-content__item', { active: activeTab === 0 }]">
								<div class="position-list">
									<div v-for="(item, index) in positionList" :key="index" class="position-item" @click="handleNavigationDeatil">
										<!-- 岗位信息区域 -->
										<div class="position-info">
											<div class="position-header">
												<h3 class="position-title">{{ item.title }}</h3>
												<div class="position-salary">{{ item.salary }}</div>
											</div>
											<div class="position-meta">
												<span class="position-location">{{ item.location }}</span>
												<span class="position-education">{{ item.education }}</span>
												<span class="position-experience">{{ item.experience }}</span>
											</div>
										</div>
										<!-- 企业信息区域 -->
										<div class="company-info">
											<div class="company-logo">
												<img src="@/assets/employment/companyLogo.png" alt="公司logo" />
											</div>
											<div class="company-detail">
												<div class="company-name">{{ item.companyName }}</div>
												<div class="company-meta">
													<span>{{ item.companySize }}</span>
													<span>{{ item.companyType }}</span>
													<span>{{ item.companyIndustry }}</span>
												</div>
											</div>
											<div class="position-actions">
												<span v-if="item.isCollected" class="action-btn collect-btn is-collected">
													<svg-icon icon-class="collect"></svg-icon>
													已收藏
												</span>
												<span v-if="item.isDelivered" class="action-btn deliver-btn is-delivered">
													<svg-icon icon-class="deliver"></svg-icon>
													已投递
												</span>
											</div>
										</div>
									</div>

									<!-- 分页器 -->
									<jr-pagination
										:limit="pageOptions.limit"
										:page.sync="pageOptions.page"
										:total="pageOptions.total"
										layout="prev, pager, next"
										prev-text="上一页"
										next-text="下一页"
										@change="handlePaginationChange"
									></jr-pagination>
								</div>
							</div>
							<!-- 已投递内容区域--end -->
							<!-- 关注内容区域--start -->
							<div :class="['tab-pane-content__item', { active: activeTab === 1 }]">
								关注
							</div>
							<!-- 关注内容区域--end -->
							<!-- 消息内容区域--start -->
							<div :class="['tab-pane-content__item', { active: activeTab === 2 }]">
								消息
							</div>
							<!-- 消息内容区域--end -->
						</div>
					</div>
				</div>
			</div>
			<!-- 数据分析--start -->
			<div class="information-data">
				<div class="data-card">
					<div class="section-simple-title">
						<h4>
							人员分析
							<span class="tag-member-mini tag-member--vip">VIP</span>
						</h4>
					</div>

					<div class="section-dot-title">技能分析</div>

					<div class="divider-title">
						<span class="title-text">证件数量</span>
					</div>

					<div class="process-chart-box">
						<progress-chart
							:value="80"
							title="较高"
							sub-title="证件数量超过80%人"
							color="#ff6a3d"
							height="200px"
							width="100%"
						></progress-chart>
					</div>

					<div class="process-chart-box">
						<progress-chart
							:value="80"
							title="较高"
							sub-title="证件数量超过80%同类人"
							color="#ff6a3d"
							height="200px"
							width="100%"
						></progress-chart>
					</div>

					<!-- 广告位 -->
					<div class="poster-container">
						<img src="@/assets/qualificationQuery/vip1.jpg" alt="新人福利包" />
					</div>

					<div class="divider-title">
						<span class="title-text">证书级别</span>
					</div>

					<div class="process-chart-box">
						<progress-chart
							:value="80"
							title="较高"
							sub-title="证件数量超过80%人"
							color="#ff6a3d"
							height="200px"
							width="100%"
						></progress-chart>
					</div>

					<div class="process-chart-box">
						<progress-chart
							:value="80"
							title="较高"
							sub-title="证件数量超过80%同类人"
							color="#ff6a3d"
							height="200px"
							width="100%"
						></progress-chart>
					</div>

					<div class="divider-title">
						<span class="title-text">技能分析</span>
					</div>

					<div class="lin-chart-box">
						<distribution-line-chart
							:chart-data="[30, 45, 5, 15, 5]"
							:x-axis-data="['1级', '2级', '3级', '4级', '5级']"
							:your-position="1"
							line-color="#3174ff"
							area-color="rgba(24, 144, 255, 0.1)"
							marker-color="#296dba"
							width="100%"
							height="200px"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ProgressChart from '@/components/Chart/ProgressChart.vue'
	import DistributionLineChart from '@/components/Chart/DistributionLineChart.vue'
	import JrPagination from '@/components/Pagination'

	export default {
		name: 'Job',
		components: {
			ProgressChart,
			DistributionLineChart,
			JrPagination
		},
		props: {},
		data() {
			return {
				// 当前激活的选项
				activeTab: 0,
				// tab选项
				recruitmentTabs: [
					{
						name: '已投递'
					},
					{
						name: '关注'
					},
					{
						name: '消息'
					}
				],
				positionList: [
					{
						title: 'PMC注册安全工程师',
						isCollected: true,
						isDelivered: true,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: true,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: true,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					},
					{
						title: 'PMC注册安全工程师',
						isCollected: false,
						isDelivered: false,
						salary: '15K~20K/月',
						location: '武汉·洪山区',
						education: '本科',
						experience: '3~5年',
						companyName: '中安华力建设集团有限公司',
						companySize: '100-499',
						companyType: '国有企业',
						companyIndustry: '房地产开发商'
					}
				],
				pageOptions: {
					currentPage: 1,
					limit: 10,
					total: 100
				}
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			// 分页
			handlePaginationChange(pager) {
				// const { page, limit } = pager
			},

			handleNavigationDeatil() {
				this.$router.push({
					path: '/employment/job-detail'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';
	@import '~@/styles/employment.scss';

	.job-container {
		background-color: #eff6f9;
		.job-content {
			width: $main-page-width;
			margin: 0 auto;
			padding: 20px 0;
			display: flex;

			.information-main {
				flex: 1;
				margin-right: 20px;
				// 基本信息
				.resume-info {
					display: flex;
					align-items: center;
					background-color: #fff;
					padding: 30px 20px;
					margin-bottom: 20px;

					.avatar-container {
						width: 100px;
						height: 100px;
						border-radius: 50%;
						overflow: hidden;
						margin-right: 40px;

						.avatar-img {
							width: 100%;
							object-fit: cover;
						}
					}

					.basic-info {
						flex: 1;

						.name-container {
							display: flex;
							align-items: center;
							margin-bottom: 15px;

							.name {
								margin-right: 15px;
								font-size: 24px;
								font-weight: bold;
							}

							.tags {
								display: flex;
								flex-wrap: wrap;

								.tag {
									background-color: #e5f1fc;
									color: #236fca;
									padding: 5px 10px;
									border-radius: 4px;
									margin-right: 10px;
									font-size: 16px;

									&.tag-status {
										margin-right: 30px;
										color: #fff;
										background-color: #2599fb;
										border-radius: 0px 10px 0px 10px;
									}
								}
							}
						}

						.cert-info {
							display: flex;
							.cert-item {
								margin-right: 20px;
								font-size: 16px;

								&:not(:last-child)::after {
									content: '|';
									margin-left: 20px;
									color: #999999;
								}

								.cert-label {
									color: #999999;
								}

								.cert-value {
									color: #333;
									font-weight: 500;
								}
							}
						}
					}

					.salary-info {
						min-width: 150px;
						text-align: left;

						.salary-label {
							font-size: 16px;
							color: #333333;
							margin-bottom: 15px;
						}

						.salary {
							font-size: 20px;
							font-weight: bold;
							color: #fe5012;
						}
					}
				}

				// 投递信息
				.delivery-container {
					padding: 20px;
					background-color: #fff;
					overflow: hidden;

					.position-list {
						.position-info {
							margin-right: 10px;
						}

						.position-header {
							.position-title {
								flex: unset;
							}

							.position-salary {
								min-width: 90px;
								font-size: 16px;
								color: #ff5013;
							}
						}

						.company-info {
							width: 430px;

							.company-logo {
								flex: 0 0 72px;
							}
						}

						.position-actions {
							flex-direction: column;
							margin-left: 10px;
							flex: unset;
							.action-btn {
								margin-left: 0;
								white-space: nowrap;

								& + .action-btn {
									margin-top: 10px;
								}
							}
						}
					}
				}
			}

			.information-data {
				width: 300px;
				background-color: #fff;

				.data-card {
					padding: 20px;
				}

				.process-chart-box {
					height: 130px;
					margin: 20px 0;
				}
			}
		}
	}
</style>
